import React, { Fragment } from 'react';
import { DownloadOutlined } from '@ant-design/icons';

const TooltipMobilekeyInfo = ({
  history,
}) => {
  const moveToApp = () => {
    const appLink = 'https://ovalmms.page.link/key';
    window.open(appLink);
  };

  return (
    <Fragment>
      <p className='mb-8 ml-5 mr-5 fs-16 c-darkgray bold'>모바일키 사용방법</p>
      <p className='mb-0 ml-5 mr-5 ws-pl wb-ka c-black'>1. <span className='pointer c-blue bold underline' onClick={moveToApp}>모바일키 전용앱 다운 받기<DownloadOutlined className='ml-3'/></span></p>
      <p className='mb-0 ml-5 mr-5 ws-pl wb-ka c-black'>2. 4자리 인증코드 입력하기</p>
      <p className='mb-0 ml-5 mr-5 ws-pl wb-ka c-black'>3. 객실 도어락 터치해서 도어락 열기</p>
    </Fragment>
  );
};

export default TooltipMobilekeyInfo;